import { SVGProps, Ref, forwardRef } from 'react';

export const TreeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M10.657 14.2c-.02.704-.093 1.121-.38 1.41l-.076.069C9.805 16 9.178 16 8 16l-.832-.006c-.664-.017-1.079-.08-1.369-.315l-.076-.07c-.288-.288-.36-.705-.38-1.409z"
                fill="currentColor"
            />
            <path
                d="M8.182.009c.886.082 1.47.778 2.566 2.09l1.116 1.334c.776.928 1.164 1.392.723 1.722-.202.151-.523.232-1.004.277l1.385 1.43c.998 1.032 1.497 1.548.93 1.914-.238.154-.604.242-1.14.294l1.314 1.222c1.22 1.134 1.83 1.702 1.136 2.106l-.124.063c-.666.301-1.985.335-4.362.339H5.278c-2.377-.004-3.695-.038-4.362-.34l-.125-.062c-.607-.354-.215-.832.71-1.707l.427-.399L3.242 9.07c-.535-.052-.901-.14-1.14-.294-.496-.32-.177-.756.58-1.55l.35-.364 1.383-1.43c-.48-.044-.8-.126-1.002-.277-.386-.289-.138-.68.45-1.395l.273-.327 1.116-1.334C6.422.699 7.008 0 8 0z"
                fill="currentColor"
            />
        </g>
    </svg>
));
TreeFilledSize16Glyph.displayName = 'TreeFilledSize16Glyph';
